import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import bind from 'bind-decorator';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./CloudAccessSelector.less');
const cx = classnames.bind(styles);

@observer
export class CloudAccessSelector extends React.Component<any, any>
{
    @bind
    _onSelectCloudAccess(product:Product)
    {
        return ()=>
        {
            controllers.ui.productSelection.selectCloudAccess(product);
        };
    }

    render()
    {
        const {storefront} = rootState.data;
        const {cloudAccessProducts} = storefront;

        if( !cloudAccessProducts )
            return null;

        return <Row className={cx('cloudAccessPlansRow')}>
                    {
                        cloudAccessProducts
                            .map((product:Product)=>
                            {
                                const grant = JSON.parse(product.grant);

                                return  <Column key={product.productId}
                                                onClick={this._onSelectCloudAccess(product)}
                                                className={cx('productCardColumn')}>

                                    <div className={cx('productName')}>
                                        {product.name}
                                    </div>

                                    <div className={cx('productDescription')}>
                                        {product.description}
                                    </div>

                                    <Column className={cx('grantSection')}>
                                        {grant.maxUsers}
                                        <div className={cx('label')}>
                                            {grant.maxUsers>1?'Users':'User'}
                                        </div>
                                    </Column>

                                    <Column className={cx('grantSection')}>
                                        {grant.maxApplications}

                                        <div className={cx('label')}>
                                            {grant.maxApplications>1?'Published Apps':'Published App'}
                                        </div>
                                    </Column>

                                    {controllers.ui.productSelection.isCloudAccessSelected(product) ?
                                        <WSPButton className={cx('ctaButton', 'buttonCurrentlySelectedPlan')}
                                                   iconClassName={cx('buttonIconCurrentlySelectedPlan')}
                                                   onClick={this._onSelectCloudAccess(product)}
                                                   style={ButtonStyle.Simple}
                                                   intent={MDIntent.Success}
                                                   icon={MDIcons.common.Checkmark}
                                                   caption={null}
                                        />

                                        :
                                        <WSPButton className={cx('ctaButton', 'buttonSelectPlan')}
                                                   onClick={this._onSelectCloudAccess(product)}
                                                   style={ButtonStyle.Simple}
                                                   intent={MDIntent.Default}
                                                   caption={'Select'}/>
                                    }

                                </Column>;
                            })
                    }
                </Row>;
    }
}
